<template>
    <div
        class="nav-sub-item relative text-sm group flex flex-row gap-2 px-4 py-2.5 items-center cursor-pointer hover:bg-gray-hover"
        :class="activeClass"
        @click="handleClick"
    >
        <span class="flex-1 line-clamp-1" :title="child.title">{{ child.title }}</span>
    </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import { BORDER_ACTIVE_CLASS, LIGHT_ACTIVE_CLASS } from '../constants';
import type { IMenuItem } from '../types';

const props = defineProps<{
    child: IMenuItem;
    inTooltip?: boolean;
}>();

const handleClick = () => {
    props.child?.onClick?.(props.child);
};

const activeClass = computed(() => {
    if (props.child.active) {
        if (props.inTooltip) {
            return LIGHT_ACTIVE_CLASS;
        }
        return BORDER_ACTIVE_CLASS;
    }
    return '';
});
</script>
